// "use client";

import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useInsertionEffect,
} from 'react';
// import { useGlobalContext } from "../../context/context";
import Tree, { TreeNode } from 'rc-tree';
import axios from 'axios';
import { DataContext } from '../../../context/DataProvider.tsx';
// import { title } from 'process';

const T2tree = () => {
  const [tdata, setData] = useState([]);
  const treeRef = useRef();
  const {
    setTitleSubInfo,

    toggleSabt,
    isTokenExpired,
    tokenLogin,
    fetchRefreshToken,
    setPIdChapter,
    pIdChapter,
    titChapterInfo,
    setTitChapterInfo,
    chapterSectionText,
    setChapterSectionText,
  } = useContext(DataContext);

  useEffect(() => {
    setPIdChapter(23);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true);
      try {
        const result = await axios(
          `${process.env.REACT_APP_BASE_URL}/api/data/SubjectsTree${
            pIdChapter === null ? '' : '?parent=' + pIdChapter
          }`,
          // `${process.env.REACT_APP_BASE_URL}/api/data/SubjectsTree`,
        );
        setData(result.data);
        // console.log('result.data', result.data);
        // setLoading(false);
      } catch (error) {
        console.log('errorfetchDataSubjectsTree', error);
        // setLoading(false);
      }
    };

    fetchData();

    return () => {};
  }, [toggleSabt, pIdChapter]);

  const onSelect = (selectedKeys, info) => {
    // console.log('selected', selectedKeys);
    // console.log('info', info);
    // console.log('info.node', info.node);
    // setTitSubID((tit) => ({
    //   ...tit,
    //   ID: info.node.key,
    //   Title: info.node.title,
    // }));
    // setTitleSubInfo((tit) => ({
    //   ...tit,
    //   ID: info.node.key,
    //   Title: info.node.title,
    // }));

    const upsertSubFun = () => {
      try {
        // console.log('info.node.key', info.node.key);
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Subject/GetById?id=${info.node.key}`,
          {
            method: 'Get',
          },
        ).then((res) => {
          // console.log('res', res);
          if (!res.ok) {
            throw new Error('کد وضعیت خطا در درخواست!' + res.status);
          }
          return res
            .json()
            .then((data) => {
              console.log('data ابواب و فصول', data);

              setTitChapterInfo({
                ID: data.id,
                Title: data.title,
                Parent_ID: data.parent_ID,
                Definition: data.definition,
                Code: data.code,
                Ordering: data.ordering,
                Type_ID: data.type_ID,
                Keywords: data.keywords,
                Old_IDs: data.old_IDs,
                MainLaw_IDs: data.mainLaw_IDs,
                Section_ID: data.section_ID,
                IsActive: data.isActive,
                isChecked: data.isChecked,
              });

              if (data.parent_ID !== null) {
                const fetchChapterText = () => {
                  // if (!isTokenExpired(tokenLogin.data?.accessToken)) {
                  try {
                    // console.log('info.node.key', info.node.key);
                    fetch(
                      `${process.env.REACT_APP_BASE_URL}/api/Subject/ChapterText?id=${data.parent_ID}`,
                      {
                        method: 'Get',
                      },
                    ).then((res) => {
                      // console.log('res', res);
                      if (!res.ok) {
                        throw new Error(
                          'کد وضعیت خطا در درخواست!' + res.status,
                        );
                      }
                      return res
                        .json()
                        .then((data) => {
                          // console.log('data', data);
                          setChapterSectionText(data);
                        })
                        .catch((error) => {
                          console.log('error', error);
                        });
                    });
                  } catch (error) {
                    console.log('error', error);
                  }
                };
                fetchChapterText();
              } else {
                setChapterSectionText([]);
              }
            })
            .catch((error) => {
              console.log('error', error);
            });
        });
      } catch (error) {
        console.log('error', error);
      }
    };

    upsertSubFun();

    // this.selKey = info.node.props.eventKey;
    // alert(selectedKeys[0]);
    // console.log(tdata);

    let hero = document.getElementById(selectedKeys[0]);
    //e.preventDefault();  // Stop Page Reloading
    hero && hero.scrollIntoView();

    // setSubjects(selectedKeys[0]);
    // setPage(1);
  };

  return (
    <Tree
      ref={treeRef}
      className="myCls"
      defaultExpandAll
      treeData={tdata ? tdata : ''}
      onSelect={onSelect}
      height={'auto'}
    />
  );
};

export default T2tree;
